import { ofType, Actions } from '@ngrx/effects'
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { BulkAction, BulkActionEvent } from 'src/app/shared/interfaces'

import {
  Component,
  OnInit,
  ChangeDetectorRef
} from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Store } from '@ngrx/store'

import { Course } from '../course'
import { courseActions } from '../course.actions'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { environment } from 'src/environments/environment'
import { catchError, distinctUntilChanged, take } from 'rxjs/operators'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { NotificationService } from '../../../core/notification.service'
import { DuplicatedCoursesModalComponent } from './duplicated-courses-modal/duplicated-courses-modal.component'
import { BsModalService } from 'ngx-bootstrap/modal'
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'
import { courseSelectors } from '../course.selectors'
import { dmsTableSelectors } from 'src/app/shared/components/dms-table/dms-table.selectors'
import { TableType } from 'src/app/shared/constants'
import { CourseService } from '../course.service'
import { Location } from '@angular/common'
import { productActions } from '../../product/product.actions'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { GenericMainWrapperModalComponent } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal.component'
import { getNavItems } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal-utils'
import { NavItemType } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal-constants'
@UntilDestroy()
@Component({
  selector: 'courses-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class CourseIndexComponent implements OnInit {
  public isLoading$: Observable<boolean>
  private course: Course
  public selectedType: string = 'active'
  public form: UntypedFormGroup
  public BulkAction = BulkAction
  public courseModuleConfig = environment.moduleConfigs.courseModule
  public actualTab: number = 0
  private totalcoursescopy = 0
  private totalcoursescopy$: Subject<number> = new Subject<number>()
  public refreshData$ = new BehaviorSubject<boolean>(true)
  public accessRights = AccessRights
  private duplicatedCourses = []
  private originDuplicatedCourses = []
  private actionSubscription: Subscription
  public defaultTab: number = 0
  private activatedRoute: ActivatedRoute
  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private courseService: CourseService,
    private changeDetectorRef: ChangeDetectorRef,
    private store: Store<AppState>,
    private modalService: BsModalService,
    private router: Router,
    private notificationService: NotificationService,
    private actions$: Actions,
    private fb: UntypedFormBuilder
  ) {
    this.activatedRoute = route
  }
  ngOnInit(): void {
    const navigationEntries = performance.getEntriesByType(
      'navigation'
    ) as PerformanceNavigationTiming[]
    if (
      navigationEntries.length > 0 &&
      navigationEntries[0].type === 'back_forward' &&
      navigationEntries[0].name.includes('(modal:') &&
      this.route.outlet == 'primary'
    ) {
      this.router.navigate(
        [
          {
            outlets: {
              modal: null
            }
          }
        ],
        { replaceUrl: true }
      )
    }
    if (
      navigationEntries.length > 0 &&
      navigationEntries[0].type === 'reload'
    ) {
      //hard Refresh
      this.router.navigate(
        [
          {
            outlets: {
              modal: null
            }
          }
        ],
        { replaceUrl: true }
      )
    }
    this.form = this.fb.group({
      isActive: [true, []],
      selectedType: ['all', []]
    })

    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe((form) => {
      if (this.form.controls.isActive.value === true) {
        this.actualTab = 0
      } else {
        this.actualTab = 1
      }
    })
    this.store
      .select(dmsTableSelectors.selectFeature(TableType.COURSES))
      .pipe(take(1))
      .subscribe((item) => {
        if (item) {
          this.actualTab = item.activeTab
          this.defaultTab = item.activeTab
          if (this.actualTab == 0) this.form.controls['isActive'].setValue(true)
          else this.form.controls['isActive'].setValue(false)
        } else {
          this.form.controls['isActive'].setValue(true)
        }
      })
  }

  public onClickRow(course: Course) {
    this.courseService.showModal = true
    if (course) {
      if (course.productId) {
        this.store.dispatch(
          productActions.fetchOneById({
            id: course?.productId,
            params: RequestQueryBuilder.create({
              join: [{ field: 'linkedSubscriptions' }]
            })
          })
        )
      }
      if (course.id) {
        this.store.dispatch(
          courseActions.fetchOneById({
            id: course?.id
          })
        )
      }
    }
    const modalRef = this.modalService.show(GenericMainWrapperModalComponent, {
      initialState: {
        navItems: getNavItems(
          String(course.id),
          {
            fullAccess: this.courseModuleConfig.fullAccess,
            isActive: this.courseModuleConfig.isActive
          },
          NavItemType.COURSE
        ),
        actions: courseActions,
        entity: course,
        joins: [
          { field: 'linkedSubscriptions' },
          { field: 'linkedSubscriptions.translations' }
        ],
        selectIdRouteParam$: this.store.select(
          courseSelectors.selectIdRouteParam
        ),
        moduleConfigIsActive: this.courseModuleConfig.isActive,
        entities$: this.store.select(courseSelectors.selectEntities),
        modalRoute: 'modal-course',
        service: this.courseService,
        type: NavItemType.COURSE,
        fallbackChildRoute: 'participation'
      },
      class: 'modal-lg modal-dialog-scrollable modal-dialog-centered'
    })
    modalRef.onHide.pipe(take(1)).subscribe((modal) => {
      this.courseService.showModal = false
      if (modalRef.content.shouldRefreshParent) {
        this.refreshData$.next(true)
      }

      if (this.courseService.redirectToElement) {
        this.courseService.redirectToElement = true
        if (this.courseModuleConfig.fullAccess) {
          this.router.navigate(
            [
              {
                outlets: {
                  primary: `courses/${course.id}`,
                  modal: null
                }
              }
            ],
            { replaceUrl: true }
          )

          return
        }

        this.router.navigate(
          [
            {
              outlets: {
                primary: `courses/${course.id}/publication`,
                modal: null
              }
            }
          ],
          { replaceUrl: true }
        )
        return
      }
      this.router.navigate(
        [
          {
            outlets: {
              modal: null
            }
          }
        ],
        { replaceUrl: true }
      )
      this.courseService.redirectToElement = false
    })
  }
  public routerFromModal() {
    if (!this.course) return
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/courses/${this.course.id}`])
    )
    this.router.navigateByUrl(url)
  }
  public onClickCreate() {
    this.router.navigate(['/courses/create'])
  }

  public onClickSelectedType(type: string) {
    this.form.controls.selectedType.patchValue(type)
  }

  public onBulkAction(bulkActionEvent: BulkActionEvent) {
    if (bulkActionEvent.action == BulkAction.COPY) {
      this.duplicatedCourses = []
      this.originDuplicatedCourses = []
      this.totalcoursescopy = 0
      if (!bulkActionEvent.items || bulkActionEvent.items.length == 0) {
        return
      }

      bulkActionEvent.items.map((course) => {
        let { id, documents, tags, ...myCourse } = course

        this.store
          .select(courseSelectors.selectEntities)
          .pipe(take(1))
          .subscribe((item) => {
            this.originDuplicatedCourses = [
              ...this.originDuplicatedCourses,
              item[course.id]
            ]
            this.store
              .select(persistentUserRoleSelectors.selectSelectedUserRole)
              .pipe(take(1))
              .subscribe((pUr) => {
                const siteId =
                  pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
                this.store.dispatch(
                  courseActions.createOne({
                    entity: {
                      ...myCourse,
                      availableParticipantCount: 0,
                      currentParticipantCount: 0,
                      description: `${id}#` + myCourse.description,
                      siteId: siteId
                    }
                  })
                )
              })
          })
      })

      this.actionSubscription = this.actions$
        .pipe(
          ofType(courseActions.upsertMany),
          untilDestroyed(this),

          catchError((error) => {
            this.actionSubscription.unsubscribe()
            return of(null)
          })
        )
        .subscribe((action) => {
          if (!action) {
            return
          }
          this.duplicatedCourses = [
            ...this.duplicatedCourses,
            action.entities[0]
          ]

          this.totalcoursescopy = this.totalcoursescopy + 1
          this.totalcoursescopy$.next(this.totalcoursescopy)
        })

      this.totalcoursescopy$
        .pipe(untilDestroyed(this), distinctUntilChanged())
        .subscribe((totalcourses) => {
          if (totalcourses == bulkActionEvent.items.length) {
            this.notificationService.emit('alerts.success', 'success')
            this.actionSubscription.unsubscribe()
            const modalRef = this.modalService.show(
              DuplicatedCoursesModalComponent,
              {
                initialState: {
                  duplicatedCourses: this.duplicatedCourses
                },
                class: 'modal-md modal-dialog-scrollable'
              }
            )
            modalRef.onHide.pipe(take(1)).subscribe(() => {
              this.refreshData$.next(true)
            })
          }
        })
    }
  }
  public onTabSelected(tab: number): void {
    this.actualTab = tab
    if (tab === 1) {
      this.form.controls.isActive.setValue(false)
    } else {
      this.form.controls.selectedType.setValue(true)
    }
  }
}
